import React, {FC, ReactNode, useState} from 'react'

import {IAuthContext} from "@containers/auth/types/authContext";


export const AuthContext = React.createContext<IAuthContext | null>(null)

interface IProps {
    children: ReactNode,
}

export const AuthContextProvider: FC<IProps> = ({
                                                    children,
                                                }) => {


    const [isAuth, setIsAuth] = useState(false)

    return (
        <AuthContext.Provider
            value={{
                isAuth, setIsAuth,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContextProvider;
